import { API } from "@/lib/api";

// Logos : fond blanc rendu transparent côté backend (flood-fill bords, blanc
// intérieur préservé, original intact). Sources non reconnues : inchangées.
export function transparentLogoUrl(url = "") {
  if (!url) return url;
  if (url.includes("/uploads/logo/transparent")) return url;
  const eligible =
    /res\.cloudinary\.com\/[^/]+\/image\/upload\//.test(url) ||
    url.includes("/api/uploads/");
  if (!eligible) return url;
  return `${API}/uploads/logo/transparent?src=${encodeURIComponent(url)}`;
}
